import { ColorScheme } from '../types'

export interface ColorPreset {
  name: string
  lightMode: ColorScheme
  darkMode: ColorScheme
}

export const TAILWIND_PRESETS: ColorPreset[] = [
  {
    name: 'Red',
    lightMode: {
      primary: '#dc2626', secondary: '#991b1b', accent: '#f97316',
      background: '#fef2f2', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#ef4444', secondary: '#fca5a5', accent: '#fb923c',
      background: '#1a0a0a', surface: '#2a1010', text: '#fef2f2', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Orange',
    lightMode: {
      primary: '#ea580c', secondary: '#9a3412', accent: '#eab308',
      background: '#fff7ed', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#f97316', secondary: '#fdba74', accent: '#facc15',
      background: '#1a0f05', surface: '#2a1a0a', text: '#fff7ed', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Amber',
    lightMode: {
      primary: '#d97706', secondary: '#92400e', accent: '#dc2626',
      background: '#fffbeb', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#f59e0b', secondary: '#fcd34d', accent: '#ef4444',
      background: '#1a1408', surface: '#2a2210', text: '#fffbeb', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Yellow',
    lightMode: {
      primary: '#ca8a04', secondary: '#854d0e', accent: '#059669',
      background: '#fefce8', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#eab308', secondary: '#fde047', accent: '#34d399',
      background: '#1a1805', surface: '#2a260a', text: '#fefce8', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Lime',
    lightMode: {
      primary: '#65a30d', secondary: '#3f6212', accent: '#0891b2',
      background: '#f7fee7', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#84cc16', secondary: '#bef264', accent: '#22d3ee',
      background: '#0f1a05', surface: '#1a2a0a', text: '#f7fee7', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Green',
    lightMode: {
      primary: '#16a34a', secondary: '#166534', accent: '#2563eb',
      background: '#f0fdf4', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#22c55e', secondary: '#86efac', accent: '#3b82f6',
      background: '#051a0a', surface: '#0a2a14', text: '#f0fdf4', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Emerald',
    lightMode: {
      primary: '#059669', secondary: '#065f46', accent: '#7c3aed',
      background: '#ecfdf5', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#10b981', secondary: '#6ee7b7', accent: '#8b5cf6',
      background: '#051a12', surface: '#0a2a1e', text: '#ecfdf5', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Teal',
    lightMode: {
      primary: '#0d9488', secondary: '#115e59', accent: '#ec4899',
      background: '#f0fdfa', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#14b8a6', secondary: '#5eead4', accent: '#f472b6',
      background: '#051a17', surface: '#0a2a24', text: '#f0fdfa', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Cyan',
    lightMode: {
      primary: '#0891b2', secondary: '#155e75', accent: '#f59e0b',
      background: '#ecfeff', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#06b6d4', secondary: '#67e8f9', accent: '#fbbf24',
      background: '#051a1e', surface: '#0a2a30', text: '#ecfeff', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Sky',
    lightMode: {
      primary: '#0284c7', secondary: '#075985', accent: '#f43f5e',
      background: '#f0f9ff', surface: '#ffffff', text: '#0f172a', textMuted: '#64748b',
    },
    darkMode: {
      primary: '#0ea5e9', secondary: '#7dd3fc', accent: '#fb7185',
      background: '#051525', surface: '#0a2035', text: '#f0f9ff', textMuted: '#94a3b8',
    },
  },
  {
    name: 'Blue',
    lightMode: {
      primary: '#2563eb', secondary: '#1e40af', accent: '#f59e0b',
      background: '#eff6ff', surface: '#ffffff', text: '#0f172a', textMuted: '#64748b',
    },
    darkMode: {
      primary: '#3b82f6', secondary: '#93c5fd', accent: '#fbbf24',
      background: '#0a1225', surface: '#101d35', text: '#eff6ff', textMuted: '#94a3b8',
    },
  },
  {
    name: 'Indigo',
    lightMode: {
      primary: '#4f46e5', secondary: '#3730a3', accent: '#06b6d4',
      background: '#eef2ff', surface: '#ffffff', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#6366f1', secondary: '#a5b4fc', accent: '#22d3ee',
      background: '#0c0a25', surface: '#161435', text: '#eef2ff', textMuted: '#7c85a3',
    },
  },
  {
    name: 'Violet',
    lightMode: {
      primary: '#7c3aed', secondary: '#5b21b6', accent: '#f43f5e',
      background: '#f5f3ff', surface: '#ffffff', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#8b5cf6', secondary: '#c4b5fd', accent: '#fb7185',
      background: '#0f0825', surface: '#1a1035', text: '#f5f3ff', textMuted: '#7c85a3',
    },
  },
  {
    name: 'Purple',
    lightMode: {
      primary: '#9333ea', secondary: '#6b21a8', accent: '#14b8a6',
      background: '#faf5ff', surface: '#ffffff', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#a855f7', secondary: '#d8b4fe', accent: '#2dd4bf',
      background: '#120a25', surface: '#1e1035', text: '#faf5ff', textMuted: '#7c85a3',
    },
  },
  {
    name: 'Fuchsia',
    lightMode: {
      primary: '#c026d3', secondary: '#86198f', accent: '#0891b2',
      background: '#fdf4ff', surface: '#ffffff', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#d946ef', secondary: '#f0abfc', accent: '#06b6d4',
      background: '#1a0820', surface: '#2a1030', text: '#fdf4ff', textMuted: '#7c85a3',
    },
  },
  {
    name: 'Pink',
    lightMode: {
      primary: '#db2777', secondary: '#9d174d', accent: '#7c3aed',
      background: '#fdf2f8', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#ec4899', secondary: '#f9a8d4', accent: '#8b5cf6',
      background: '#1a0a14', surface: '#2a1020', text: '#fdf2f8', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Rose',
    lightMode: {
      primary: '#e11d48', secondary: '#9f1239', accent: '#0d9488',
      background: '#fff1f2', surface: '#ffffff', text: '#1c1917', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#f43f5e', secondary: '#fda4af', accent: '#14b8a6',
      background: '#1a0a0c', surface: '#2a1015', text: '#fff1f2', textMuted: '#a8a29e',
    },
  },
]

export const CURATED_PRESETS: ColorPreset[] = [
  {
    name: 'Launch Day',
    lightMode: {
      primary: '#2563eb', secondary: '#7c3aed', accent: '#06b6d4',
      background: '#ffffff', surface: '#f8fafc', text: '#0f172a', textMuted: '#64748b',
    },
    darkMode: {
      primary: '#3b82f6', secondary: '#8b5cf6', accent: '#22d3ee',
      background: '#0f172a', surface: '#1e293b', text: '#f1f5f9', textMuted: '#94a3b8',
    },
  },
  {
    name: 'Blood Moon',
    lightMode: {
      primary: '#be123c', secondary: '#7c3aed', accent: '#d97706',
      background: '#fafaf9', surface: '#ffffff', text: '#1c1917', textMuted: '#57534e',
    },
    darkMode: {
      primary: '#9f1239', secondary: '#5b21b6', accent: '#f59e0b',
      background: '#0f0f0f', surface: '#1a1a1a', text: '#f1f5f9', textMuted: '#94a3b8',
    },
  },
  {
    name: 'Forever Yours',
    lightMode: {
      primary: '#be185d', secondary: '#a21caf', accent: '#c2410c',
      background: '#fdf2f8', surface: '#ffffff', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#ec4899', secondary: '#d946ef', accent: '#f97316',
      background: '#1a0a14', surface: '#2d1524', text: '#fdf2f8', textMuted: '#a78bfa',
    },
  },
  {
    name: 'Morning Dew',
    lightMode: {
      primary: '#166534', secondary: '#78716c', accent: '#b45309',
      background: '#f0fdf4', surface: '#ffffff', text: '#14532d', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#4ade80', secondary: '#a8a29e', accent: '#f59e0b',
      background: '#052e16', surface: '#0a3d21', text: '#dcfce7', textMuted: '#86efac',
    },
  },
  {
    name: 'Disco Fever',
    lightMode: {
      primary: '#d97706', secondary: '#dc2626', accent: '#4f46e5',
      background: '#fffbeb', surface: '#fef3c7', text: '#451a03', textMuted: '#78716c',
    },
    darkMode: {
      primary: '#f59e0b', secondary: '#ef4444', accent: '#818cf8',
      background: '#1c1308', surface: '#2d2006', text: '#fef3c7', textMuted: '#a8a29e',
    },
  },
  {
    name: 'Neo Tokyo',
    lightMode: {
      primary: '#7c3aed', secondary: '#06b6d4', accent: '#ec4899',
      background: '#f5f3ff', surface: '#ede9fe', text: '#1e1b4b', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#a78bfa', secondary: '#22d3ee', accent: '#f472b6',
      background: '#0a0118', surface: '#150225', text: '#e0e7ff', textMuted: '#7c85a3',
    },
  },
  {
    name: 'Pure Form',
    lightMode: {
      primary: '#18181b', secondary: '#71717a', accent: '#3b82f6',
      background: '#ffffff', surface: '#fafafa', text: '#09090b', textMuted: '#a1a1aa',
    },
    darkMode: {
      primary: '#fafafa', secondary: '#a1a1aa', accent: '#60a5fa',
      background: '#09090b', surface: '#18181b', text: '#fafafa', textMuted: '#71717a',
    },
  },
  {
    name: 'Fifth Avenue',
    lightMode: {
      primary: '#1e293b', secondary: '#78716c', accent: '#b45309',
      background: '#fafaf9', surface: '#ffffff', text: '#0f172a', textMuted: '#6b7280',
    },
    darkMode: {
      primary: '#e2e8f0', secondary: '#a8a29e', accent: '#f59e0b',
      background: '#0a0a0a', surface: '#171717', text: '#fafaf9', textMuted: '#a1a1aa',
    },
  },
  {
    name: 'Concrete Dreams',
    lightMode: {
      primary: '#18181b', secondary: '#dc2626', accent: '#fbbf24',
      background: '#e5e5e5', surface: '#f5f5f5', text: '#09090b', textMuted: '#52525b',
    },
    darkMode: {
      primary: '#fafafa', secondary: '#ef4444', accent: '#f59e0b',
      background: '#09090b', surface: '#18181b', text: '#e5e5e5', textMuted: '#71717a',
    },
  },
  {
    name: 'Stack Overflow',
    lightMode: {
      primary: '#1e293b', secondary: '#059669', accent: '#d97706',
      background: '#f8fafc', surface: '#ffffff', text: '#0f172a', textMuted: '#64748b',
    },
    darkMode: {
      primary: '#e2e8f0', secondary: '#34d399', accent: '#fbbf24',
      background: '#0d1117', surface: '#161b22', text: '#e6edf3', textMuted: '#8b949e',
    },
  },
]

export const COLOR_PRESETS: ColorPreset[] = [...TAILWIND_PRESETS, ...CURATED_PRESETS]
